import { render, staticRenderFns } from "./RowGrupoComissao.vue?vue&type=template&id=6bbc3a6e"
import script from "./RowGrupoComissao.vue?vue&type=script&lang=js"
export * from "./RowGrupoComissao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports